import { getFeaturedArticles, type Article } from '@/mocks/articles';
import { categories, categoryMap } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  'jiaguwen-zhong-de-yin': 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20oracle%20bone%20inscriptions%20on%20turtle%20shell%20fragments%2C%20warm%20sepia%20tone%2C%20scholarly%20museum%20lighting%2C%20minimal%20composition%2C%20traditional%20Chinese%20academic%20aesthetic&width=800&height=500&seq=feat-article-01&orientation=landscape',
  'yin-zi-wuti-yanbian': 'https://readdy.ai/api/search-image?query=Chinese%20calligraphy%20evolution%20showing%20different%20script%20styles%20from%20seal%20to%20cursive%2C%20ink%20brush%20on%20rice%20paper%2C%20warm%20natural%20light%2C%20artistic%20scholarly%20atmosphere&width=800&height=500&seq=feat-article-02&orientation=landscape',
  'cong-yin-dao-yin': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20bronze%20vessel%20inscriptions%20with%20detailed%20character%20carvings%2C%20warm%20museum%20lighting%2C%20textured%20metal%20surface%2C%20scholarly%20archaeological%20photography&width=800&height=500&seq=feat-article-03&orientation=landscape',
  'yin-zi-ben-yi-kao': 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20dictionary%20Shuowen%20Jiezi%20pages%20with%20character%20explanations%2C%20aged%20paper%20texture%2C%20warm%20lighting%2C%20scholarly%20library%20setting%2C%20antique%20book%20aesthetic&width=800&height=500&seq=feat-article-04&orientation=landscape',
  'yin-zi-yuyi-wangluo': 'https://readdy.ai/api/search-image?query=Mind%20map%20style%20diagram%20of%20Chinese%20character%20semantic%20network%20on%20aged%20paper%2C%20warm%20sepia%20tones%2C%20scholarly%20diagram%2C%20traditional%20Chinese%20aesthetic%2C%20ink%20brush%20annotations&width=800&height=500&seq=feat-article-05&orientation=landscape',
  'shijing-zhong-de-yin': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Book%20of%20Songs%20Shijing%20manuscript%20on%20bamboo%20slips%2C%20warm%20natural%20lighting%2C%20traditional%20Chinese%20literary%20atmosphere%2C%20scholarly%20museum%20display&width=800&height=500&seq=feat-article-06&orientation=landscape',
  'zuozhuan-xianqin-yin': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20chronicle%20Zuozhuan%20text%20on%20aged%20paper%20scroll%2C%20warm%20sepia%20tones%2C%20traditional%20Chinese%20history%20book%2C%20scholarly%20atmosphere&width=800&height=500&seq=feat-article-07&orientation=landscape',
  'shuowenjiezi-xunshi-yin': 'https://readdy.ai/api/search-image?query=Qing%20dynasty%20Chinese%20philology%20books%20with%20red%20ink%20annotations%2C%20traditional%20scholarly%20study%2C%20warm%20lighting%2C%20aged%20paper%20texture%2C%20academic%20aesthetic&width=800&height=500&seq=feat-article-08&orientation=landscape',
  'rujia-lijiao-zhong-de-yin': 'https://readdy.ai/api/search-image?query=Confucian%20classic%20texts%20Analects%20on%20traditional%20Chinese%20paper%2C%20warm%20lighting%2C%20ink%20brush%20and%20calligraphy%2C%20philosophical%20scholarly%20atmosphere%2C%20ancient%20Chinese%20books&width=800&height=500&seq=feat-article-09&orientation=landscape',
  'le-er-bu-yin-kongzi': 'https://readdy.ai/api/search-image?query=Portrait%20of%20Confucius%20teaching%20disciples%20in%20traditional%20Chinese%20ink%20wash%20painting%20style%2C%20warm%20sepia%20tones%2C%20scholarly%20classical%20Chinese%20aesthetic%2C%20harmonious%20composition&width=800&height=500&seq=feat-article-10&orientation=landscape',
  'yin-zi-xiandai-hanyu': 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20dictionary%20and%20digital%20corpus%20display%20side%20by%20side%2C%20blending%20traditional%20and%20contemporary%2C%20warm%20lighting%2C%20academic%20linguistics%20research%20setting&width=800&height=500&seq=feat-article-11&orientation=landscape',
};

export default function FeaturedArticles() {
  const articles = getFeaturedArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              最新发布的深度研究文章，带你深入汉字文化的世界
            </p>
          </div>
          <Link
            to="/category/zixing-yanbian"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticleCard({ article }: { article: Article }) {
  const cat = categoryMap[article.category];
  const imgSrc = articleImages[article.slug] || articleImages['jiaguwen-zhong-de-yin'];
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="relative h-44 md:h-48 overflow-hidden">
          <img
            src={imgSrc}
            alt={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          {cat && (
            <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-700">
              {cat.name}
            </span>
          )}
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors duration-200">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
            <span>{article.publishDate}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}